import dayjs from 'dayjs'

const initialState = () => ({
  timestampMessageAlreadySent: false,
  widgetDisplayHideTimestamp: null,
})

export const state = initialState()

export const mutations = {
  SET_WIDGET_HIDE_TIMESTAMP(state, payload) {
    state.widgetDisplayHideTimestamp = payload
  },
  RESET_WIDGET_HIDE_TIMESTAMP(state) {
    state.widgetDisplayHideTimestamp = null
  },
  TIMESTAMP_MESSAGE_SENT(state) {
    state.timestampMessageAlreadySent = true
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const actions = {
  setWidgetDisplayVisibilityTime({ commit, rootState }) {
    if (!rootState.Widget.fullframeOptions.persistencyChatboxVisibility) {
      return
    }

    const timeoutBeforeClosing = dayjs().add(
      rootState.Widget.fullframeOptions.persistencyChatboxVisibility,
      'second',
    )
    commit('SET_WIDGET_HIDE_TIMESTAMP', timeoutBeforeClosing.valueOf())
  },
  setTimestampMessage({ state, commit, dispatch }, target) {
    if (!state.timestampMessageAlreadySent) {
      dispatch(
        'Messages/pushTimestampMessage',
        { target: target },
        { root: true },
      )

      commit('TIMESTAMP_MESSAGE_SENT')
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
